<template>
  <div>
    <div>
      <div class="company-hero">
        <h2 class="p-5 text-uppercase --white">
          {{ $t('pages.forgot-password.title') }}
        </h2>
      </div>
    </div>

    <b-card
      class="mx-auto text-left mt-5 p-md-5"
      style="width: 80%;"
    >
      <div
        v-if="!emailSent"
        class="row"
      >
        <div
          class="col-12 font-weight-bold text-center pb-3"
          style="font-size: 0.9rem;"
        >
          {{ $t('pages.forgot-password.instructions') }}
        </div>
        <div class="col-12">
          <form class="text-center">
            <b-form-group
              id="fieldset-email"
              label-for="email"
              :invalid-feedback="$t('inputs.email.validation')"
              :state="emailState"
              style="font-size: 0.95rem"
            >
              <b-form-input
                id="email"
                v-model="data.email"
                size="sm"
                :placeholder="$t('inputs.email.title')"
              />
            </b-form-group>
            <b-button
              variant="success"
              :disabled="!readyToSend"
              size="sm"
              style="text-transform: uppercase"
              @click="submit"
            >
              {{ $t('pages.forgot-password.reset-password') }}
            </b-button>
          </form>
        </div>
      </div>
      <div v-else>
        {{ $t('pages.forgot-password.success-message', { email: data.email }) }}
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        email: ""
      },
      loginStart: true,
      emailSent: false
    }
  },
  computed: {
    emailState() {
      /*eslint-disable */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      /*eslint-enable */
      return (
        re.test(String(this.data.email).toLowerCase()) || this.loginStart
      );
    },
    readyToSend() {
      return this.emailState;
    }
  },
  methods: {
    submit() {
      this.loginStart = false;

      if(this.readyToSend) {
        this.axios.post('/auth/password/send', this.data)
          .then( response => {
            if(response.data === "OK")
              this.emailSent = true;
          })
          .catch( error => {
            this.emailSent = false;
            this.$toastNotification('danger', '', error.response.data);
          });
      }
    }
  }
}
</script>

<style lang="scss">
.invalid-feedback {
  font-size: 0.9rem;
}

.company-hero {
    background: url('../../assets/company-hero.png');
  }
</style>
